export default "__VITE_ASSET__Bfe2aa79__"